module.exports = __webpack_public_path__ + "static/media/intro.ebb2a865.mp3";